import { CreateDoctorRegisterStepPendency } from 'domain/usecases/doctor-register-step-pendency/create-doctor-register-step-pendency'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteCreateDoctorRegisterStepPendency
  implements CreateDoctorRegisterStepPendency
{
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  add(
    params: CreateDoctorRegisterStepPendency.Params
  ): Promise<CreateDoctorRegisterStepPendency.Model> {
    return this.doctorRepository.createDoctorRegisterStepPendency(params)
  }
}
